// node-type-badge.ts — PSTUDIO-3624
// A workflow node is either a Decision (badge "D") or an Action (badge "A").
// The mapping mirrors node-type-cell.tsx; kept pure + shared so the Expanded
// Cell View panel header and the table's Node Type cell always agree on the
// badge letter.
export type NodeTypeBadgeLetter = 'D' | 'A';

export function getNodeTypeBadgeLetter(nodeType: unknown): NodeTypeBadgeLetter {
  const value = typeof nodeType === 'string' ? nodeType.toLowerCase() : '';
  return value === 'decision' || value === 'd' ? 'D' : 'A';
}

// The badge is colored per node type so it's easy to recognize at a glance
// (Mostafa's feedback, PSTUDIO-3624): Decision = baby blue, Action = mint green
// — the canonical node-type colors used across the app + DS icons. This maps the
// node type to the SCSS modifier suffix; the colors themselves live in
// expanded-cell-view-panel.scss (.c-expanded-cell-view__node-type-badge--*).
export type NodeTypeBadgeModifier = 'decision' | 'action';

export function getNodeTypeBadgeModifier(
  nodeType: unknown
): NodeTypeBadgeModifier {
  return getNodeTypeBadgeLetter(nodeType) === 'D' ? 'decision' : 'action';
}
